import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "mdi mdi-translate"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_InputGroupAddon = _resolveComponent("InputGroupAddon")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.isLocked)
    ? (_openBlock(), _createBlock(_component_InputGroup, {
        key: 0,
        class: "dex-input-text"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_InputText, _mergeProps(_ctx.$attrs, {
            value: _ctx.translatedDescription,
            readonly: _ctx.isReadonly
          }), null, 16, ["value", "readonly"]),
          _createVNode(_component_InputGroupAddon, { class: "dex-input-text__addon" }, {
            default: _withCtx(() => [
              (_ctx.showTranslationLink)
                ? _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                    key: 0,
                    to: _ctx.resolvedTranslationUrl,
                    class: "dex-input-text__icon-link"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "mdi mdi-translate" }, null, -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('Squeeze.System.TranslationFieldLockedLink'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_1, null, 512)), [
                    [
                      _directive_tooltip,
                      _ctx.$t('Squeeze.System.TranslationFieldLocked'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_InputText, _mergeProps({ key: 1 }, _ctx.$attrs, { readonly: _ctx.isReadonly }), null, 16, ["readonly"]))
}